document.addEventListener('DOMContentLoaded', function () {
  let swiper;

  const slider = document.querySelector('.slider-gallery');

  if (slider) {
    swiper = new Swiper(slider, {
      loop: true,
      speed: 1000,
      grabCursor: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      spaceBetween: -800,
      slidesPerView: 3,
      initialSlide: 0,
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 1000,
        modifier: 0.5,
        slideShadows: false,
        scale: 0
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
          effect: 'slide',
          centeredSlides: false
        },
        768: {
          slidesPerView: 3,
          spaceBetween: -800,
          effect: 'coverflow',
          centeredSlides: true
        }
      }
    });

    slider.addEventListener('click', function (e) {
      const activeSlide = slider.querySelector('.swiper-slide-active');
      if (!activeSlide) return;

      const rect = activeSlide.getBoundingClientRect();
      const clickX = e.clientX;

      if (clickX < rect.left + rect.width / 2) {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    });
  }
});